// extracted by mini-css-extract-plugin
module.exports = {"ratingStars":"styles_ahnu_ratingStars__vJJzR","star":"styles_ahnu_star__QrOaK","count":"styles_ahnu_count___HTAp"};